import { LogisticaGuiaEstado, SriDocs, formatDocumentosRelacionados } from "@pcgerente-node/pcg-comun";
import React, { CSSProperties, useEffect, useState } from "react";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import style from "../../../../styles/paged.module.css";
import Loading from "../../../helpers/Loading/Loading";
/*Imagenes estados*/
import { CIUDAD, logistica_GUIA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { BsClipboardCheckFill } from "react-icons/bs"; //Recibido
import { GiReturnArrow } from "react-icons/gi"; //Devuelto
import anulada from "../../../../assets/img/anulada.png";
import enPlantaImg from "../../../../assets/img/en-planta.png";
import enRutaImg from "../../../../assets/img/en-ruta.png";
import entregadoImg from "../../../../assets/img/entregado.png";
import enviadoImg from "../../../../assets/img/enviado.png";
import recibidoBodegaImg from "../../../../assets/img/recibido-bodega.png";

const stylesProps1:CSSProperties ={
    color: "white"
}

const StylesProps2:CSSProperties = {
 backgroundColor: "#304aca"
}

interface ChildProps {
    contenido: logistica_GUIA[]
    ciudades: CIUDAD[]
}

const Paged: React.FC<ChildProps> = ({ contenido, ciudades }) => {

    useEffect(() => {
        if(contenido.length){
            current(1)
        }
    },[contenido])


    //States y lógica del paginado
    const [actualPage, setActualPage] = useState(1);

    const contenidoPorPágina = 12; //muestra cuanto contenido se quiere mostrar por cada página
    const indexOfLastProduct = actualPage * contenidoPorPágina;
    const indexOfFirstProduct = indexOfLastProduct - contenidoPorPágina;
    const contenidoSliced = contenido.slice(indexOfFirstProduct, indexOfLastProduct);
    
    let pages: number[] = []; 
    setearPaginas()
    useEffect(() =>{
        if(actualPage && actualPage !==1)
            window.scrollTo(0, document.body.scrollHeight)
    },[contenidoSliced])

    return (
        ciudades.length>0 ?
        <>
        <table id="tablaBlock" className="table table-responsive">
            <thead>
                <tr style={StylesProps2}>
                    <th>
                        <div className="th-content" style={stylesProps1}>Remitente</div>                                                    
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Destinatario</div>                                                    
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Origen</div>

                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Destino</div>
                        
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Guía</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Docs. Relacionados</div>
                    </th>

                    <th>
                        <div className="th-content text-center" style={stylesProps1}>Estado</div>
                    </th>
                    <th>

                    </th>
                </tr>
            </thead>
            <tbody className="ContainerGuiasTable">
                {contenidoSliced.map((g)  =>  {
                    return(
                        <tr className={style.selectGuia} key={g.id}>
                        <td>
                            <div className="td-content customer-name">
                                    <span>{g.CLIENTE_REMITENTE?.razonSocial}</span>
                            </div>
                        </td>
                        <td>
                            <div className="td-content customer-name">
                                    <span>{g.CLIENTE_DESTINATARIO?.razonSocial}</span>
                            </div>
                        </td>

                        <td>
                            <div className="td-content Capitalize">{ciudades.filter(ciudad => ciudad.id === g.idCiudadOrigen)[0].nombre}</div>
                        </td>

                        <td>
                            <div className="td-content Capitalize ">{ciudades.filter(ciudad => ciudad.id === g.idCiudadDestino)[0].nombre}</div>
                        </td>

                        <td>
                            <div className="td-content product-invoice Capitalize">{`#${g.serie1}-${g.serie2}-${g.numeroDocumento}`}</div>
                        </td>

                        <td>
                            <div className="td-content" style={{ fontSize: '0.85rem' }}>
                                {formatDocumentosRelacionados(g)}
                            </div>
                        </td>

                        <td>
                            <div className="td-content text-center">
                                <span className="badge badge-link">
                                            {g.estado === LogisticaGuiaEstado.Planta?
                                            <>
                                                <img src={enPlantaImg} width="40" height="40" alt="En planta"/>
                                                {" En planta"} 
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.Viaje?
                                            <>
                                                <img src={enviadoImg} width="40" height="40" alt="Enviado"/>
                                                {" Enviado"}  
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.RecibidoEnBodegaTransito?
                                            <>
                                                <img src={recibidoBodegaImg} width="40" height="40" alt="En bodega"/>
                                                {" En bodega"}
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.Ruta?
                                            <>
                                                <img src={enRutaImg} width="40" height="40" alt="En ruta"/>
                                                {" En ruta"}
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.Entregada?
                                            <>
                                                <img src={entregadoImg} width="40" height="40" alt="Entregada"/>
                                                {" Entregada"}
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.Anulado?
                                            <>
                                                <img src={anulada} width="40" height="40" alt="Entregada"/>
                                                {" Anulado"}
                                            </>
                                            : 
                                            g.estado === LogisticaGuiaEstado.Recibido?
                                            <>
                                                <div className={style.devueltaIconState}>
                                                    <div><BsClipboardCheckFill/></div>
                                                    <span>{"Recibido"}</span>
                                                </div>
                                            </>
                                            :
                                            g.estado === LogisticaGuiaEstado.Devuelta?
                                            <>
                                                <div className={style.devueltaIconState}>
                                                    <div><GiReturnArrow/></div>
                                                    <span>{"Devuelta"}</span>
                                                </div>
                                            </>
                                            :
                                            <>??</>
                                        }
                                </span>
                            </div>
                        </td>
                        <td>
                        <Link to={`/home/consulta/detalles/${g.serie1}-${g.serie2}-${g.numeroDocumento}`} target="_blank"  rel="noopener noreferrer" className={style.externalLink}>
                            <GoLinkExternal/>
                        </Link>
                        </td>
                    </tr>

                    )
                    })
                }
            </tbody>
        </table>
            

        {
            contenido.length>15?
            <>
            <div className={`${style.container}`} id="paginado">
                <ul className={style.containerPages}>
                <button id={style.btnHidden} className={`${style.button} ${(actualPage === 0 || actualPage === 1)? style.hiddenButton: style.buttonHover}`} onClick={() =>current(actualPage-1)}>{'<'}</button>
                    {slicedPaged().map(page=>{
                        if(page === actualPage){
                            return(
                                <li onClick={() => current(page)} className={`${style.page} ${style.pageActual}`} key={page} > {page} </li>
                            )
                        }
                        else return(
                            <li onClick={() => current(page)} className={style.page} key={page}> {page} </li>
                            )
                    })}
                <button id={style.btnHidden} className={`${style.button} ${ (pages[pages.length-1] <= 1 ||actualPage === pages[pages.length-1] || contenido.length < 1 )? style.hiddenButton: style.buttonHover}`} onClick={() =>current(actualPage+1)}>{">"}</button>
                </ul>
            </div>
            </>

            :
            <></>
        }

        </>
        :
        <Loading/>
    )



    //función recorredora del paginado
    function current(numberpage: number){
        setActualPage(numberpage);
    };

    function setearPaginas(){
        if (contenido.length > 0) {
            for (let i = 1; i <= Math.ceil(contenido.length / contenidoPorPágina); i++) {
                pages.push(i);
            }
        }
    }

    //logica de recorrido del páginado
    function slicedPaged() {
        if (actualPage <= 3) {
            const slice = pages.slice(0, 7);
            return slice;
        }
        if (actualPage > 3 && pages[actualPage + 3] !== undefined) {
            const slice = pages.slice(actualPage - 4, actualPage + 3);
            return slice;
        } else if (actualPage > 3 && pages[actualPage + 4] === undefined) {
            const slice = pages.slice(pages.length - 7, pages.length);
            return slice;
        }
        return [1]
    };

}



export default Paged